import React, { useEffect, useState } from "react";
import { Modal, Row, Col } from "antd";
import velogic from "../assets/gcs-velogic.png";
import { useHistory } from "react-router-dom";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { find, map } from "lodash";
import COLORS from "common/Colors";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRoleList, getUserRoleId, getUserRoleList, getUserInfo, getMenuList, } from "redux/selectors";
import { setUserRole, setDepartmentId } from "redux/actions";
import { DEVICE } from "common/Device";
import Header from "molecules/Header";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding: 1.5rem 3rem;
  }
  .select-role-title {
    margin-bottom: 0rem;
  }
  .select-role-sub-title {
    color: #8a8a8a;
    padding-bottom: 2rem;
  }
`;

const ModalHeaderRow = styled(Row)`
  padding-bottom: 2rem;
`;

const StyledRoleCol = styled(Col)`
  padding: 2rem 3rem;
  text-align: center;
  .role-button {
    width: 200px;
    margin: auto;
    padding: 0.8rem 1rem;
    box-shadow: 0px 0px 5px ${COLORS.GREY};
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
  }
  .role-button.selected {
    background: ${COLORS.PRIMARY};
    color: ${COLORS.WHITE};
  }
  @media ${DEVICE.tablet} {
    padding: 1rem;
    .role-button {
      width: 100%;
    }
  }
`;

const StyledRolsSubmitButtonContainer = styled.div`
  padding-top: 2rem;
  text-align: right;
  .ant-btn {
    width: 8rem;
    font-weight: bold;
    height: 40px;
    background: ${COLORS.PRIMARY};
  }
  @media ${DEVICE.mobileL} {
    text-align: center;
  }
  .user_switch_header{
    display: none;
  }
`;
const StyledTitle = styled.div`
  h4.select-role-sub-title {
    font: normal normal normal 14px/24px LatoWeb !important;
  }
  h2.select-role-title {
    font: normal normal normal 21px/29px LatoWeb;
  }
`;

const ModalBrandLogoImage = styled.img`
  height: 30px;
`;
function SwitchUserModal({
  userRoleModal,
  closeModal,
  userRole,
  userRoleId,
  roleList,
  onDashboardPg,
  userInfo,
  menuList,
  saveDepartmentId
}) {
  const [selectedRole, setSelectedRole] = useState(userRoleId);
  let history = useHistory();

  const filterRoleList = roleList?.filter(item => userInfo?.role_id?.includes(item.roleId)) || [];

  // useEffect(() => {
  //   const setRoleList = find(roleList, { 'roleId': userRoleId });
  //    setSelectedRole(userRoleId);
  //     saveDepartmentId(setRoleList?.department);
  // }, [userRoleId]);

  const redirectToDashboard = (key) => {
    userRole(key);
    closeModal();
   
    const Menulist = menuList[userRoleId] || Object.values(menuList)[0] 
  
    const filtermenulist =
      Menulist &&
      Menulist.filter(
        (data) =>
          data.key !== "managerdashboard" &&
          data.key !== "hrdashboard" &&
          data.key !== "teamcalendar" &&
          data.key !== "allcalendar"
      );
    let defaultPath = '/';

    const myTeamCalendarAccess = (Menulist && Menulist.filter(
      (data) =>
        data.key === "teamcalendar" ||
        data.key === "allcalendar"
    )) || [];
  
    const myTeamDashBoardAccess = (Menulist && Menulist.filter(
      (data) =>
        data.key === "hrdashboard" ||
        data.key === "managerdashboard"
    )) || [];
  
    const canViewCalendar = myTeamCalendarAccess.some(menu => menu.permission.view);
    const canViewDashboard = myTeamDashBoardAccess.some(menu => menu.permission.view);
  
    for (const menuItem of filtermenulist) {
      
      if (
        (menuItem.access === true &&
        menuItem.path !== "managementview" &&
        menuItem.path !== "reportpreference") ||   (menuItem.key === "mycalendar" && canViewCalendar) ||
        (menuItem.key === "dashboard" && canViewDashboard)
      ) {
        if (menuItem.subMenu && menuItem.subMenu.length > 0) {
          defaultPath = menuItem.subMenu[0].path;
        } else {
          defaultPath = menuItem.path;
        }
        break;
      }
    }
    if (onDashboardPg === true) {
      history.push(`/${defaultPath}`);
    }
  };
  const redirectToDashboard1 = (key) => {
    userRole(key);
    closeModal();
  };

  // const fetchMasterData = async (fetch_master_data, clientId) => {
  //   const {
  //     code,
  //   } = await CALL_API(`master-data/${clientId}`, "post", {
  //     fetch_master_data,
  //   });
  //   if (code === STATUS_CODE.SUCCESS) {
  //     const setRoleList = find(roleList, { 'roleId': userRoleId });
  //     saveDepartmentId(setRoleList?.department);
  //   } 
  // };

  return (
    <StyledModal
      centered
      visible={userRoleModal}
      closable={false}
      footer={false}
      keyboard={false}
      maskClosable={false}
      width="70%"
    >
      <ModalHeaderRow>
        <Col span={12}>
          <ModalBrandLogoImage src={velogic} />
        </Col>
        <Col span={12} className="align-right">
          {onDashboardPg && (
            <IconButton onClick={() => redirectToDashboard1(selectedRole)}>
              <CloseIcon />
            </IconButton>
          )}
        </Col>
      </ModalHeaderRow>
      <StyledTitle>
        <h2 className="select-role-title">Select user role</h2>
        <h4 className="select-role-sub-title">
          Let us know who you are logging in as so that we can provide you with
          relevant content.
        </h4>
      </StyledTitle>
      <Row>
        {map(filterRoleList, ({ roleId: key, roleName: text, index }) => {
          return (
            <StyledRoleCol md={12} sm={24} xs={24} key={key}>
              <div
                onClick={() => {
                  setSelectedRole(key);
                  redirectToDashboard(key);
                }}
                className={`role-button ${(
                  key.length > 1 && index === 0
                    ? onDashboardPg
                    : key === selectedRole && onDashboardPg
                )
                  ? "selected"
                  : ""
                  }`}
              >
                {text}
              </div>
            </StyledRoleCol>
          );
        })}
      </Row>

      <StyledRolsSubmitButtonContainer>
        <div className="user_switch_header">
          <Header redirectToDashboard={redirectToDashboard} />
        </div>
      </StyledRolsSubmitButtonContainer>
    </StyledModal>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  userRoleList: getUserRoleList(state),
  userInfo: getUserInfo(state),
  menuList: getMenuList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      userRole: setUserRole,
      saveDepartmentId: setDepartmentId,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SwitchUserModal);
